import { render } from "./AppConstruccion.vue?vue&type=template&id=40ed0f78"
import script from "./AppConstruccion.vue?vue&type=script&lang=js"
export * from "./AppConstruccion.vue?vue&type=script&lang=js"

import "./AppConstruccion.vue?vue&type=style&index=0&id=40ed0f78&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_b7c0161fc3875e000d6ad7ba26fe3ce3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__